
import { Vue, Component, Watch } from 'vue-property-decorator';
import { getNewsList, getBaseInfo } from '../api/wap';
import NewsItem from '@/components/News/NewsItem .vue';
import { List } from 'vant';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  classId: string = '0';
  async created() {
    const res: any = await getBaseInfo();
    this.classId = res.data.classId;
    this.onLoad();
  }
  onLoad() {
    const data = {
      page: this.page,
      pageSize: 10,
      columnId: this.classId,
    };
    getNewsList(data).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.statusCode !== 200) {
      this.finished = true;
    } else {
      if (!res.data.list || res.data.list.length === 0) {
        this.finished = true;
      } else {
        if (!res.data.list || res.data.list.length === 0) {
          this.finished = true;
        } else {
          this.list = [...this.list, ...res.data.list];
        }
      }
    }
    this.loading = false;
  }
}
